<template>
    <div class="container">
        <div class="top-box">
            <img src="../../../static/images/index/bg_attend.png" class="bgImg" alt="" />
            <div>观众预登记</div>
        </div>
        <div class="step-box">
            <div class="active">
                <div>1</div>
                <span>资料填写</span>
            </div>
            <div :class="{'active':step>1}">
                <div>2</div>
                <span>填写问卷</span>
            </div>
            <div :class="{'active':step==3}">
                <div>3</div>
                <span>查看门票</span>
            </div>
        </div>

        <!-- 资料填写 -->
        <template v-if="step==1">
            <div class="info-box">
                <div class="ib_title">个人信息</div>
                <div class="line_item">
                    <div><span class="redStar">姓名</span></div>
                    <div><input type="text" placeholder="请输入您的真实姓名" placeholder-class="pClass" v-model="info.Name"></input></div>
                </div>
                <div class="line_item">
                    <div><span class="redStar">电话</span></div>
                    <div><input type="number" placeholder="请输入您的手机号码" placeholder-class="pClass" v-model="info.Mobile"></input></div>
                </div>
                <div class="line_item">
                    <div><span class="redStar">验证码</span></div>
                    <div class="li_code">
                        <input type="number" placeholder="请输入手机验证码" placeholder-class="pClass" v-model="info.Code" @blur="codeOnBlur"></input>
                        <button :disabled="disabled" @click.stop="getCode">{{sendText}}</button>
                    </div>
                </div>
                <div class="line_item">
                    <div><span class="redStar">邮箱</span></div>
                    <div><input type="text" placeholder="请输入邮箱号" placeholder-class="pClass" v-model="info.Email"></input></div>
                </div>
                <div class="line_item radio">
                    <div><span class="redStar">证件类型</span></div>
                    <div>
                    <div data-type="1" @click.stop="info.IdType=1"><span class="iconfont" :class="info.IdType==1?'icon-radio-on':'icon-radio'"></span>身份证</div>
                    <div data-type="3" @click.stop="info.IdType=3"><span class="iconfont" :class="info.IdType==3?'icon-radio-on':'icon-radio'"></span>回乡证（港澳居民来往内地通行证）</div>
                    <div data-type="4" @click.stop="info.IdType=4"><span class="iconfont" :class="info.IdType==4?'icon-radio-on':'icon-radio'"></span>台胞证（台湾居民来往大陆通行证）</div>
                    </div>
                </div>
                <div class="line_item">
                    <div><span class="redStar">证件号码</span></div>
                    <div><input :type="info.IdType==1?'idcard':'text'" placeholder="请输入正确的证件号码" placeholder-class="pClass" v-model="info.IdCode"></input></div>
                </div>
            </div>
            <div class="info-box">
                <div class="ib_title" style="margin-bottom:0rpx;">公司信息</div>
                <div class="ib_tips">请如实填写以下信息，部分内容将打印在观展吊牌上。</div>
                <div class="line_item">
                    <div><span class="redStar">名称</span></div>
                    <div><input type="text" placeholder="请输入公司名称" placeholder-class="pClass" v-model="info.CompanyName"></input></div>
                </div>
                <div class="line_item">
                    <div><span class="redStar">职位</span></div>
                    <div class="li_dropdown" @click.stop="dutyShow=true">
                        <input type="text" placeholder="请选择" placeholder-class="pClass" :value="info.Duty" readonly></input>
                        <span class="iconfont icon-arrow-down"></span>
                    </div>
                </div>
                <van-popup v-model="dutyShow" round position="bottom">
                    <van-picker
                        show-toolbar
                        title=""
                        :columns="dutyArray"
                        :default-index="dutyIdx"
                        @cancel="dutyShow = false"
                        @confirm="dutyConfirm"
                    />
                </van-popup>
                <div class="line_item" style="border-bottom:0;" @click="open">
                    <div><span class="redStar">地址</span></div>
                    <div class="li_dropdown" style="border-bottom:1px solid #ddd;">
                        <input type="text" :value="info.ProvinceName+' '+info.CityName+' '+info.RegionName" readonly v-if="info.ProvinceName"></input>
                        <input type="text" placeholder="请选择省市区县" placeholder-class="pClass" readonly v-else></input>
                        <span class="iconfont icon-arrow-down"></span>
                    </div>
                </div>
                 <!-- 省市区picker -->
                <van-popup v-model="showPicker" round position="bottom">
                    <van-picker
                        ref="areaPicker"
                        show-toolbar
                        title=""
                        :columns="columns"
                        @cancel="showPicker = false"
                        @confirm="onConfirm"
                    />
                </van-popup>
                <div class="line_item">
                    <div></div>
                    <div><input type="text" placeholder="请输入详细地址" placeholder-class="pClass" v-model="info.Address"></input></div>
                </div>
            </div>
            <template v-if="type!=1">
                <image src="https://cdn.alighting.com/wxopen/preregistration/adv01.jpg" mode="widthFix" class="advImg"></image>
            </template>
            <div class="btn-box">
                <div data-elementid="datafill" @click.stop="nextClick">下一步</div>
            </div>
        </template>
 
        <!-- 填写问卷 -->
        <template v-else-if="step==2">
            <div class="info-box">
                <div v-for="(item, index) in questionsList" :key="index">
                    <template v-if="qIndex==index">
                        <div class="ib_title">
                            {{item.title}}
                            <span>({{item.title_type_id==3?'填空':item.title_type_id==2?('可多选，最少'+item.least_count+'项，最多'+item.most_count+'项'):'单选，必选1项'}})</span>
                            <span class="num">{{index+1}}/{{questionsList.length}}</span>
                        </div>
                        <div class="question-box">
                            <!-- 1单选 2多选 3填空 -->
                            <template v-if="item.title_type_id == 3">
                                <textarea placeholder="请填写" placeholder-class="pClass" v-model="questionsList[index].other"></textarea>
                            </template>
                            <template v-else>
                                <div v-for="(aItem, aIndex) in item.option_list" :key="aIndex">
                                    <div class="qb_item" @click.stop="checkboxClick(aIndex)">
                                        <span class="iconfont" :class="aItem.check?'icon-checkbox-fill':'icon-checkbox'"></span>
                                        <div>
                                            <span>{{aItem.option}}<!-- {{aItem.is_order==1?'：':''}}--></span>
                                            <input type="text" placeholder="请填写" placeholder-class="pClass" v-model="questionsList[index].option_list[aIndex].other" 
                                            @click.stop='return false;' v-if="aItem.is_order==1"></input>
                                        </div>  
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>   
            </div>
            <div class="btn-box">
                <div class="white" @click.stop="prevClick">{{qIndex==0?'上一步':'上一题'}}</div>
                <div data-elementid="questionnaire" @click.stop="nextClick" :style="submitting?'pointer-events:none':'pointer-events:auto'">
                    {{qIndex < (questionsList.length-1)?'下一题':'提交'}}
                </div>
            </div>
        </template>
    </div>
</template>
<script>
  import { Popup, Picker, Icon } from "vant";
  import { beforeInfo, dutyList, questionList, checkInfo, addRecords, addViews } from "@/api/exhibition";
  import { getRegionList } from "@/api/member";
  import { sendSMS } from "@/api/login";
  export default {
    name: "attendinfo",
    components: {
      "van-popup": Popup,
      "van-picker": Picker,
      "van-icon": Icon
    },
    data() {
        return {
            timer: null,

            step: 1, //1资料填写 2填写问卷 3查看门票
            sid: 0,
            mid: 0,
            type: 1, //隐藏广告 1隐藏 0不隐藏
            cnid: 0, //渠道

            sendText: "获取验证码",
            disabled: false,
            //职业列表
            dutyShow: false,
            dutyArray: [],
            dutyIdx: 0,
            //省市区
            columns: [],
            showPicker: false,
            //问卷列表
            qIndex: 0,
            questionsList: [],

            info: {
                "Name": "",
                "Duty": "",
                "Mobile": "",
                "IdCode": "",
                "IdType": 1, //1身份证 3回乡证（港澳居民来往内地通行证） 4台胞证（台湾居民来往大陆通行证）
                "Address": "",
                "CityName": "",
                "CompanyName": "",
                "ProvinceName": "",
                "RegionName": "",
                "Email": "",
                "ShareMemberId": 0,
                "ShareStoreId": 0,
                "Code": "",
                "ExhibitionQuestions": [] //展会问卷
            },
            submitting: false //提交中
        };
    },
    computed: {

    },
    methods: {
        // 获取验证码
        getCode: function () {
            var that = this;
            that.info.Mobile = that.info.Mobile.trim();
            // 手机号码格式验证
            if (!(/^1[3456789]\d{9}$/.test(that.info.Mobile))) {
                that.Common.toast("输入手机号有误！");
                return false;
            }
            sendSMS({
                "Mobile": that.info.Mobile,
                "Type": 6
            }).then((res) => {
                that.Common.toast('验证码已发送', 'success');
                that.disabled = true;
                that.countDown();
            }, fail => {
                that.disabled = false;
            })
        },
        // 60秒后重新获取验证码
        countDown: function () {
            var that = this;
            var num = 60;
            if (that.timer) {
                clearInterval(that.timer);
            }
            that.timer = setInterval(function () {
                if (num > 0) {
                    that.sendText = num + "s";
                    num--;
                } else {
                    clearInterval(that.timer);
                    that.sendText = "重新发送";
                    that.disabled = false;
                }
            }, 1000)
        },
        // 失去焦点-获取预登记信息
        codeOnBlur: function (e) {
            var that = this;
            // 手机号码格式验证
            if (!(/^1[3456789]\d{9}$/.test(that.info.Mobile))) {
                that.Common.toast("输入手机号有误！");
                return false;
            }
            if (that.info.Code == "") return false;

            beforeInfo({
                "Mobile": that.info.Mobile,
                "Code": that.info.Code,
            }).then((res) => {
                //处理职位数据
                var dutyIdx = 0;
                that.dutyArray.forEach(function (item, index) {
                    if (data.Data.Duty == item) {
                        dutyIdx = index;
                        return;
                    }
                })
                that.dutyIdx = dutyIdx;
                that.info.CompanyName = data.Data.CompanyName;
                that.info.Duty = data.Data.Duty;
                that.info.ProvinceName = data.Data.ProvinceName;
                that.info.CityName = data.Data.CityName;
                that.info.RegionName = data.Data.RegionName;
                that.info.Address = data.Data.Address;

                that.checkArea();
            }, fail => {
                if(fail.Msg == "已报名"){
                    that.Common.toast(fail.Msg);
                    localStorage.setItem('mobile', that.info.Mobile);
                    setTimeout(() => {
                        this.$router.push({ path:"/ticket" });
                    }, 1000)
                } else if(fail.Msg.indexOf('登记信息') > -1){

                } else {
                    that.Common.toast(fail.Msg);
                }
            });
        },
        // 打开省市区
        open: function () {
            this.showPicker = !this.showPicker;
            // if (this.showPicker) this.checkArea();
        },
        // 检验区域-重置
        checkArea: function () {
            if(this.columns.length > 0 && this.info.ProvinceName && this.info.CityName && this.info.RegionName){
                var cityData = [], regionData = [];
                var provinceIndex = 0, cityIndex = 0, regionIndex = 0;
                this.columns.forEach((item, index) => {
                    // 省
                    if (this.info.ProvinceName == item.text) {
                        provinceIndex = index;
                        item.children.forEach((citem, cindex) => {
                            // 市
                            cityData.push(citem.text);
                            if (this.info.CityName == citem.text) {
                                cityIndex = cindex;
                                citem.children.forEach((ritem, rindex) => {
                                    // 区
                                    regionData.push(ritem.text);
                                    if (this.info.RegionName == ritem.text) {
                                        regionIndex = rindex;
                                    }
                                });
                            }
                        });
                    }
                    return false;
                });
                if(cityData.length > 0 && regionData.length > 0){
                    this.$nextTick(() => {
                        const picker = this.$refs.areaPicker;
                        picker.setColumnValues(1, cityData);
                        picker.setColumnValues(2, regionData);
                        picker.setIndexes([provinceIndex, cityIndex, regionIndex]);
                    });
                }
            } 
        },
        // 省市区选择确定
        onConfirm(value) {
            this.info.ProvinceName = value[0];
            this.info.CityName = value[1];
            this.info.RegionName = value[2];
            this.showPicker = false;
        },
        // 职位选择确定
        dutyConfirm(event){
            this.info.Duty = event;
            this.dutyShow = false;
        },
        // 下一步点击
        nextClick: function (e) {
            var that = this;
            if (that.step == 1) { //资料填写
                if (that.info.Name == '') {
                    that.Common.toast("姓名不能为空");
                    return false;
                }
                that.info.Mobile = that.info.Mobile.trim();
                // 手机号码格式验证
                if (!(/^1[3456789]\d{9}$/.test(that.info.Mobile))) {
                    that.Common.toast("输入手机号有误");
                    return false;
                }
                if (that.info.Code == '') {
                    that.Common.toast("验证码不能为空");
                    return false;
                }
                if (!(/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(that.info.Email))) {
                    that.Common.toast("输入邮箱格式有误");
                    return false;
                }
                if (that.info.IdCode == '') {
                    that.Common.toast(that.info.IdType == 1 ? '身份证号码不能为空' : '证件号码不能为空');
                    return false;
                }
                if (that.info.CompanyName == '') {
                    that.Common.toast("公司名称不能为空");
                    return false;
                }
                if (that.info.Duty == '') {
                    that.Common.toast("职位不能为空");
                    return false;
                }
                if (that.info.ProvinceName == '' || that.info.CityName == '' || that.info.RegionName == '') {
                    that.Common.toast("所在地区不能为空");
                    return false;
                }
                if (that.info.Address == '') {
                    that.Common.toast("详细地址不能为空");
                    return false;
                }
                that.checkExhibitionVisitInfo();
            } else { //填写问卷
                var data = that.questionsList[that.qIndex];
                // 是否必填、必写
                if (data.is_required == 1) {
                    if (data.title_type_id == 3) {
                        // 3填空
                        if (!data.other || data.other == "") {
                            that.Common.toast("请填写");
                            return false;
                        }
                    } else if (data.title_type_id == 2) {
                        // 2多选
                        var judgeCount = 0;
                        var judgeInput = true;
                        data.option_list.forEach(function (item, index) {
                            if (item.check) {
                                judgeCount += 1;
                                if (item.is_order == 1 && (item.other == undefined || item.other == null || item.other == "")) {
                                    // 需要填写
                                    judgeInput = false;
                                }
                            }
                        })
                        if (judgeCount < data.least_count) {
                            that.Common.toast(`请最少选择${data.least_count}项`);
                            return false;
                        }
                        if (!judgeInput) {
                            that.Common.toast('勾选的内容需要填写');
                            return false;
                        }
                    } else {
                        // 1单选
                        var judgeRadio = false;
                        var judgeInput = true;
                        data.option_list.forEach(function (item, index) {
                            if (item.check) {
                                judgeRadio = true;
                                if (item.is_order == 1 && (item.other == undefined || item.other == null || item.other == "")) {
                                    // 需要填写
                                    judgeInput = false;
                                }
                                return;
                            }
                        })
                        if (!judgeRadio) {
                            that.Common.toast('请选择');
                            return false;
                        }
                        if (!judgeInput) {
                            that.Common.toast('勾选的内容需要填写');
                            return false;
                        }
                    }
                }

                if (that.qIndex < that.questionsList.length - 1) {
                    that.qIndex = that.qIndex + 1;
                    window.scrollTo(0, 0);
                } else {
                    //最后一条问题、既是提交时，处理问卷数据
                    var exhibitionQuestions = [];
                    that.questionsList.forEach(function (item1, index1) {
                        exhibitionQuestions[index1] = {};
                        exhibitionQuestions[index1].title_id = item1.title_id;
                        exhibitionQuestions[index1].title_result = "";
                        exhibitionQuestions[index1].option_list = [];
                        if (item1.title_type_id == 3) {
                            // 3填空
                            exhibitionQuestions[index1].title_result = item1.other;
                        } else {
                            // 1单选 2多选
                            item1.option_list.forEach(function (item2, index2) {
                                if (item2.check) {
                                    exhibitionQuestions[index1].option_list.push({
                                        "option_id": item2.option_id,
                                        "option": item2.is_order == 1 ? item2.other : item2.option,
                                        "is_order": item2.is_order
                                    })
                                }
                            })
                        }
                    })
                    that.info.ExhibitionQuestions = exhibitionQuestions;
                    that.addExhibitionVisitRecords();
                }
            }
        },
        // 上一步点击
        prevClick: function () {
            if (this.qIndex == 0) {
                this.step = this.step - 1;
            } else {
                this.qIndex = this.qIndex - 1;
            }
            window.scrollTo(0, 0);
        },
        // 下一步校验-(资料填写)
        checkExhibitionVisitInfo: function () {
            var that = this;
            var info = that.info;
            checkInfo({
                "Name": info.Name,
                "Mobile": info.Mobile,
                "IdCode": info.IdCode,
                "IdType": info.IdType,
                "Email": info.Email,
                "Code": info.Code
            }).then((res) => {
                that.step = 2;
                window.scrollTo(0, 0);
            })
        },
        // 问卷选择
        checkboxClick: function (idx) {
            var data = this.questionsList[this.qIndex];
            if (data.is_checkbox == 1) { //多选
                if (!data.option_list[idx].check) {
                    var multiCheckCount = 0;
                    data.option_list.forEach(function (item, index) {
                        if (item.check) {
                            multiCheckCount += 1;
                        }
                    })
                    if (multiCheckCount >= data.most_count) {
                        this.Common.toast( `最多可选${data.most_count}项`);
                        return false;
                    }
                }
                data.option_list[idx].check = !data.option_list[idx].check;
            } else { //单选
                data.option_list.forEach(function (item, index) {
                    item.check = index == idx ? true : false;
                })
            }
            this.$set(this.questionsList, this.qIndex, data);
        },

         // 添加预登记信息
        addExhibitionVisitRecords: function () {
            var that = this;
            var info = that.info;
            that.submitting = true;
            addRecords({
                "Name": info.Name,
                "Duty": info.Duty,
                "Mobile": info.Mobile,
                "IdCode": info.IdCode,
                "IdType": info.IdType,
                "Address": info.Address,
                "CityName": info.CityName,
                "CompanyName": info.CompanyName,
                "ProvinceName": info.ProvinceName,
                "RegionName": info.RegionName,
                "Email": info.Email,
                "ShareMemberId": that.mid,
                "ShareStoreId": that.sid,
                "Code": info.Code,
                "ExhibitionQuestions": info.ExhibitionQuestions,
                "CnId": that.cnid,
            }).then((res) => {
                setTimeout(() => {
                    that.Common.toast('门票领取成功！', 'success');
                    localStorage.setItem('mobile', info.Mobile);
                    setTimeout(() => {
                        this.$router.push({ path:"/ticket" });
                    }, 1500)
                }, 0);
            }, fail => {
                that.submitting = false;
            })
        }
    },
    mounted() {
        var that = this;
        // 提示
        // that.Common.showMsg("2025广州国际照明展览会（光亚展）\n观众预登记通道暂未开启，请耐心等候", function () {
        //     that.$router.push({ path:"/exhibition" });
        // });
        // return false;
       
        that.cnid = that.$route.query.cnid || 0;
        addViews({ "CnId": that.cnid }).then((res) => {})
        dutyList().then((res) => {
            that.dutyArray = res.Data;
        })
        getRegionList().then((res) => {
            var list = [];
            res.Data.forEach((item, index) => {
                list.push({
                    "text": item.Name,
                    "children": []
                });
                item.Sub.forEach((sitem, sindex) => {
                    list[index].children.push({
                        "text": sitem.Name,
                        "children": []
                    });
                    sitem.Sub.forEach((pitem, pindex) => {
                        list[index].children[sindex].children.push({
                            "text": pitem.Name
                        });
                    });
                });
            });
            that.columns = list;
        });
        questionList().then((res) => {
            that.questionsList = res.Data;
        })
    },
  };
  </script>
  <style scoped src="../../../static/css/attendinfo.css"></style>
  